module.exports = __webpack_public_path__ + "img/05_MEDIA.32b5da7b.png";